"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModuleExecutionContext = void 0;
const Module_1 = require("./Module");
class ModuleExecutionContext {
    #cardCollection = [];
    #executionId;
    #isExecuting;
    #dataProvider;
    #summaryBuilder;
    #visibilityObserver;
    #domEventSender;
    #module;
    #priceFormatter;
    #impressionId;
    #summaryCounter;
    #htmlElementAttributeHandler;
    #runMode;
    constructor(module, summaryBuilder, visibilityObserver, dataProvider, domEventSender, priceFormatter, impressionId, summaryCounters, htmlElementAttributeHandler, runMode) {
        this.#runMode = runMode;
        this.#executionId = generateUniqueId();
        this.#module = module;
        this.#dataProvider = dataProvider;
        this.#visibilityObserver = visibilityObserver;
        htmlElementAttributeHandler;
        this.#summaryBuilder = summaryBuilder;
        this.#isExecuting = true;
        this.#domEventSender = domEventSender;
        this.#priceFormatter = priceFormatter;
        this.#impressionId = impressionId;
        this.#summaryCounter = summaryCounters;
        this.#htmlElementAttributeHandler = htmlElementAttributeHandler;
    }
    get summaryCounters() {
        return this.#summaryCounter;
    }
    get impressionId() {
        return this.#impressionId;
    }
    get module() {
        return this.#module;
    }
    get isSilentMode() {
        return this.#runMode === Module_1.RunMode.Silent;
    }
    get executionId() {
        return this.#executionId;
    }
    get isExecuting() {
        return this.#isExecuting;
    }
    finishExecution() {
        this.#isExecuting = false;
    }
    get summaryBuilder() {
        return this.#summaryBuilder;
    }
    get visibilityObserver() {
        return this.#visibilityObserver;
    }
    get dataProvider() {
        return this.#dataProvider;
    }
    get domEventSender() {
        return this.#domEventSender;
    }
    get cards() {
        return this.#cardCollection;
    }
    get priceFormatter() {
        return this.#priceFormatter;
    }
    get moduleConfig() {
        return this.#module.config;
    }
    get htmlElementAttributeHandler() {
        return this.#htmlElementAttributeHandler;
    }
    get runMode() {
        return this.#runMode;
    }
}
exports.ModuleExecutionContext = ModuleExecutionContext;
const generateUniqueId = () => {
    return Math.random().toString(36).substring(2);
};
